module.exports = __webpack_public_path__ + "static/img/hall_3.cfaab4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/hall_3.jpg
// module id = +D3j
// module chunks = 3